import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export const CheckBoxer = (props: {
  value: boolean | undefined;
  name: string;
  label?: string;
  className?: string;
  onChange: (value: boolean, name: string, error: string) => any;
}) => {
  const { onChange } = props;

  return (
    <FormControlLabel
      className={props.className}
      control={
        <Checkbox
          checked={props.value}
          color="secondary"
          onChange={React.useCallback(
            (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked, props.name, ''),
            [onChange, props.name]
          )}
          name={props.name}
        />
      }
      label={props.label}
    />
  );
};
